export default __webpack_public_path__ + "static/media/swe.faa4d6de.png";